import React from "react";
import { Link, useNavigate } from "react-router-dom";

import Hero from "../components/hero/hero";
import ReviewComponent from "../components/review/review";
import AspectContainer from "../components/aspect-container/aspect-container";

import HttpService from "../services/http.service";
import EventService from "../services/event.service";

import { StorageContext } from "../components/storage/storage-context";

import { EventPerformance, Review, Theme, UpdateType } from "../models/models";

import { timeData } from "../models/models";
import Update from "../components/update/update";
import config from "../config/config";
import EventsCalendarMonth from "../components/events-calendar/events-calendar-month";
import ThreeCard from "../components/home/three-card";

const { periods, weekdays, months, daysPerMonth, years, dates, times } = timeData;

const Home: React.FC<any> = (props: any) => {

  const [storageContext, setStorageContext] = React.useContext(StorageContext);
  const navigate = useNavigate();

  // const [storageContext.theme, setstorageContext.theme] = React.useState<storageContext.theme | undefined>(undefined);
  const [derivedEvents, setDerivedEvents] = React.useState<EventPerformance[]>([]);
  const [reviews, setReviews] = React.useState<Review[]>([]);
  const [busy2, setBusy2] = React.useState<boolean>(true);
  const [updates, setUpdates] = React.useState<UpdateType[]>([]);
  const [updatesBusy, setUpdatesBusy] = React.useState<boolean>(true);


  React.useEffect(() => {
    (async () => {
      setDerivedEvents((await EventService.generateDerivedEvents((storageContext.events as EventPerformance[]) || [])).body!) ;
    })();
  }, [storageContext.events]);

  // React.useEffect(() => setstorageContext.theme(storageContext.storageContext.theme as storageContext.theme), [storageContext.storageContext.theme]);

  React.useEffect(() => {
    (async () => {
      setBusy2(true);
      const res2 = await HttpService.get<Review[]>('approvedreviewstream', { afterID: 0, numrows: 3 });
      if (res2.success && res2.body) {
        setReviews(res2.body);
      }   
      setBusy2(false);
    })();
    HttpService.get<UpdateType[]>('updatestream', { afterID: Number.MAX_SAFE_INTEGER, numrows: 3 }).then((urs) => {
      setUpdates(urs.body?.sort((a,b) => b.id - a.id) || []);
      setUpdatesBusy(false);
    });
  }, []);

  return (
    <div className=" relative bg-gradient-to-br from-indigo-500 via-purple-800 to-pink-700">

      <div>
        { 
          storageContext.theme &&
            <video
              playsInline webkit-playsInline webkit-playsinline controlsList="nodownload" 
              className="min-w-full h-[calc(100vh-64px)] absolute object-cover hidden md:block"
              src={`${config.ASSETS[config.ENVIRONMENT]}${(storageContext.theme as Theme).herovideo}`}//static/IMG_0358.mp4`}
              autoPlay={true} muted={true} loop={true}
            ></video>
        }

        {
          storageContext.theme &&
            <img
              className="min-w-full h-[calc(100vh-64px)] absolute object-cover md:hidden"
              src={`${config.ASSETS[config.ENVIRONMENT]}${(storageContext.theme as Theme).heroimage}`}
            ></img>
        }

        {/* invisible spacing hack */}
        <div className=" opacity-0 w-full">
          <div className="">
            <EventsCalendarMonth></EventsCalendarMonth>
          </div>
        </div>
        {/* spacing hack */}

        <div className="diamonds mt-[calc(100vh-128px)]">

          {
            !!(updates && updates.length) && (
              <div className="p-1 m-3">
                <p className="text-white ml-8 mt-8 mb-4">Latest News</p>
                {
                  updates.map((u, i) => (
                    <div key={i}>
                      <Update update={u} />
                    </div>
                    
                  ))
                }
                {
                  updatesBusy &&
                    <div className="text-center">
                      <div className="lds-roller mx-auto"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                    </div>
                }  
              </div>
            )
          }

          { 
            storageContext.theme && 
              <ThreeCard 
                cards={[
                  {
                    title: (storageContext.theme as Theme).threecard1title,
                    img: (storageContext.theme as Theme).threecard1image,
                    body: (storageContext.theme as Theme).threecard1text
                  },
                  {
                    title: (storageContext.theme as Theme).threecard2title,
                    img: (storageContext.theme as Theme).threecard2image,
                    body: (storageContext.theme as Theme).threecard2text
                  },
                  {
                    title: (storageContext.theme as Theme).threecard3title,
                    img: (storageContext.theme as Theme).threecard3image,
                    body: (storageContext.theme as Theme).threecard3text
                  }
                ]}
              />
          }

          <Hero>
            { 
              busy2 &&
                <div className="flex justify-center my-40">
                  <div className="lds-roller mx-auto"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                </div>
            }
            {
              reviews &&
                <div>
                  {
                    reviews.map((r,i) => (
                      <div className="block m-4 md:m-8" key={i}>
                        <ReviewComponent  reviewerName={r.name} reviewText={r.text} rating={r.stars} date={new Date(parseInt(r.timestamp.toString()))}></ReviewComponent>
                      </div>
                    ))
                  }
                </div>
            }
          </Hero>

        </div>
      </div>

      <div className="absolute top-0 bottom-0 left-0 right-0">
        <div className={`relative text-center`}>
          <div className={`inline-block md:block w-full md:w-1/2 lg:w-1/3 md:mx-8 md:px-4 mt-12 text-center md:text-left `}>
            <p className=" gold-text text-base md:text-lg lg:text-xl drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,1)]">
              { 
                storageContext.theme && 
                  (storageContext.theme as Theme).herotext 
              }
              {/* Get ready for ZAE – the driving force behind unforgettable house music moments. With an unparalleled ability to fuse tradition and innovation, ZAE commands dancefloors, creating a rhythmic unity that transcends. From underground vibes to festival stages, experience the pulse of ZAE's curated sonic journey that redefines house music, one set at a time.          */}
            </p> 
            {/* <button className="btn btn-primary">Get Started</button> */}
          </div>
        </div>

        <div className="absolute w-full text-center top-[calc(100vh-212px)]">
          <button 
            className="bg-slate-800 p-5 border border-slate-500 text-white bottom-6"
            onClick={() => navigate('/contact')}
          >Book Now
          </button>

        </div>
        <div className="absolute top-[calc(100vh-124px)] w-full">
          {/* <div className="relative  bg-gradient-to-br from-purple-800 to-black rounded-lg"> */}
          <div className={`relative ${ storageContext.theme?.cards.primary || `rounded-lg bg-gradient-to-br from-pink-200 via-pink-300 to-pink-200`}`}>
            <EventsCalendarMonth></EventsCalendarMonth>
          </div>
        </div>
      </div>

    </div>
  )
}

export default Home;